import { SVGProps, Ref, forwardRef } from "react";

const WarrantyShieldIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 13 15"
    fill="#FFFFFF"
    width="1em"
    height="1em"
    ref={ref}
    aria-label="Shield Icon"
    {...props}
  >
    <title id="Warranty Shield Icon">Warranty Shield Icon</title>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.667}
      d="M5.702 13.865c.147.086.22.129.325.151a.76.76 0 0 0 .28 0c.104-.022.178-.065.325-.151 1.299-.758 4.868-3.138 4.868-6.41V4.266c0-.533 0-.8-.087-1.028a1.334 1.334 0 0 0-.365-.526c-.184-.162-.433-.256-.932-.443L6.54.929A1.258 1.258 0 0 0 6.262.84a.667.667 0 0 0-.19 0 1.39 1.39 0 0 0-.281.088l-3.574 1.34c-.5.188-.749.282-.933.444a1.333 1.333 0 0 0-.364.526c-.088.229-.088.495-.088 1.028v3.189c0 3.272 3.57 5.652 4.869 6.41Z"
    />
  </svg>
);

const ForwardRef = forwardRef(WarrantyShieldIcon);
export default ForwardRef;
